import React, { Component } from "react";

//https://codepen.io/jjmartucci/pen/mVjzZP

type Props = {
	id?: string;
	placeholder?: string;
	minLength?: number;
	value: string;
	onChange: Function;
	autoComplete?: string;
};

type State = {
	show: boolean;
	value: string;
};

const defaultProps = {
	minLength: 8,
	autoComplete: "new-password",
} as Props;

class PasswordInput extends Component<Props, State> {
	constructor(props: Props = defaultProps) {
		super(props);

		this.state = {
			show: false,
			value: this.props.value || "",
		};
	}

	onChangeCallback = () => {
		this.props.onChange(this.state.value);
	};

	onChange = (e) => {
		const value = e.target.value;
		this.setState(
			{
				value: value,
			},
			this.onChangeCallback
		);
	};

	toggleShow = () => {
		this.setState({ show: !this.state.show });
	};

	render() {
		const type = this.state.show ? "text" : "password";
		return (
			<div className="password">
				<input
					{...this.props}
					type={type}
					value={this.state.value}
					onChange={this.onChange}
					minLength={this.props.minLength}
				/>
				<div onClick={this.toggleShow} className={this.state.show ? "action icon hide" : "action icon show"} />
			</div>
		);
	}
}

export default PasswordInput;
